import { companyActions } from './actions';

const companyInitState = {
  companyList: null,
  myCompanyList: null,
  company: null,
  companyAnalytics: null,
  loading: false,
  saving: false,
  exporting: false,
  error: null,
};

export function companyReducer(state = companyInitState, { type, payload }) {
  switch (type) {
    case companyActions.LOAD_COMPANY_LIST:
      return {
        ...state,
        loading: true,
      };
    case companyActions.LOAD_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        companyList: payload.data,
        loading: false,
      };
    case companyActions.LOAD_COMPANY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case companyActions.LOAD_MY_COMPANY_LIST:
      return {
        ...state,
        loading: true,
      };
    case companyActions.LOAD_MY_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        myCompanyList: payload.data,
        loading: false,
      };
    case companyActions.LOAD_MY_COMPANY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case companyActions.LOAD_COMPANY:
      return {
        ...state,
        loading: true,
      };
    case companyActions.LOAD_COMPANY_SUCCESS:
      return {
        ...state,
        company: payload.data,
        loading: false,
      };
    case companyActions.LOAD_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case companyActions.LOAD_COMPANY_ANALYTICS:
      return {
        ...state,
        loading: true,
      };
    case companyActions.LOAD_COMPANY_ANALYTICS_SUCCESS:
      return {
        ...state,
        companyAnalytics: payload.data,
        loading: false,
      };
    case companyActions.LOAD_COMPANY_ANALYTICS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case companyActions.UPDATE_COMPANY:
      return {
        ...state,
        saving: true,
      };
    case companyActions.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        saving: false,
      };
    case companyActions.UPDATE_COMPANY_FAIL:
      return {
        ...state,
        saving: false,
        error: payload.error,
      };

    case companyActions.EXPORT_COMPANY_ANALYTICS:
      return {
        ...state,
        exporting: true,
      };
    case companyActions.EXPORT_COMPANY_ANALYTICS_SUCCESS:
      return {
        ...state,
        exporting: false,
      };
    case companyActions.EXPORT_COMPANY_ANALYTICS_FAIL:
      return {
        ...state,
        exporting: false,
        error: payload.error,
      };

    default:
      return state;
  }
}
